import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("eshop:add-fast", () => {
    document.location = window.NXURLS.URL_ESHOP_CART_SUMMARY_PAGE;
  });

  $(document).on(
    "eshop:add",
    (e, data, showModal = true, refreshPage = false) => {
      $("#cart").show();

      $("#cartBlock").html(data.newCartBlock);
      $("#cartBlockMobile").html(data.newCartBlockMobile);
      $("#freeDeliveryBlock").html(data.newFreeDeliveryBlock);
      $("#freeDeliveryBlockMobile").html(data.newFreeDeliveryBlockMobile);

      if (refreshPage) {
        window.location.reload();
      }

      if (!showModal) {
        return;
      }

      if (!$("#eshopmodal").length) {
        $(document.body).append('<div id="eshopmodal"></div>');
      }

      $("#eshopmodal").html(data.cartAddedOverlay);
      window.NXCMS.modalClose($("#eshopmodal .modal"));
      window.NXCMS.modal($("#eshopmodal .modal"));
    }
  );
});
